import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/proveedores';

import Select from 'react-select';

import {api} from '../../actions/_request';
import ModalTablas from '../../components/catalogos/modal_tablas';
import Embarques from "../embarques/Modal";
import LAB from "../lab/Modal";


const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

const tipos_precios = [
  {label: 'Hardware', value: 0},
  {label: 'Administrativo', value: 1}, 
  {label: 'Comisiones', value: 2}, 
];



class ProveedorModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            proveedor: {
                id:0,
                activo:'1',
                nombre:'',
                contacto : '',
                linea:'',
                direccion : '',
                ciudad:'',
                codigo_postal:'',
                rfc : '',
                telefono: '',                             
                fax:'',
                plazo_credito:0,
                credito_disponible:0,
                cuenta_cargo:'',
                cuenta_abono:'',
                lab:'', 
                via_emb:'',               
                nota:'',
                tipo_gastos:0,
            },
            action: 'save_proveedor',
            activeTab: '1',
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',

            codigo_lab:'',
            codigo_via_emb:'',

            /*modal para agrgar nuevos registros*/
            modal_registro:0,
            tittle_registro:'',
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
        this.toggle_modal= this.toggle_modal.bind(this); 
        this.retorno= this.retorno.bind(this);
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);  
         this.toggle_modal_registro= this.toggle_modal_registro.bind(this);        
    }
    handleClose (event) {
        console.log('evento--->',event)
         
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
        switch (name) {
            case "codigo_lab":                 
                  campo = "lab";
                  tabla="/lab";
                  break;
            case "codigo_via_emb":                  
                  campo = "via_emb";
                  tabla="/embarque";
                  break;       
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                     }
                     self.retorno(response.data,campo,vaciar,value);        
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
            

   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }

    toggle_modal_registro(objeto,opcion=0,titulo=''){
      console.log('opcion---->'+opcion);
      if(opcion==0||opcion=='[object Event]'){
         document.getElementById('body').className = "modal-open modal-open";
        this.setState({
            modal : false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }else{

        this.setState({
            modal : !this.state.modal,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }
    }


     retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let campo_codigo="";
        console.log('renglon---->',objeto);
        let {proveedor} = this.state;
        let self =this;
        switch (campo) {
            case "lab":
                  codigo=objeto.value?objeto.value:objeto.id;
                  campo_codigo="codigo_lab"; 
                  proveedor[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "via_emb":
                  codigo=objeto.value?objeto.value:objeto.id;
                  campo_codigo="codigo_via_emb";
                  proveedor[campo] = objeto.value?objeto.value:objeto.id;
                  break;        
        }  
       if(vacio==1){
        console.log('vaciar')
        codigo=valor;
        proveedor[campo] =0;
       }

       
    
        self.setState({
            proveedor : proveedor,           
            [campo_codigo]:codigo,
            modal:false,         
        })


    }
      

    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            proveedor: {
                ...this.state.proveedor,
                [name]: value
            }
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

    componentDidMount()
    {
         
        let prospectoid = this.props.prospectoid;
        let self = this;
              
        if(prospectoid > 0 && prospectoid != self.state.proveedor.id)
        {

            api().get(`proveedor/${prospectoid}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        proveedor: response.data,
                        action: 'update_proveedor',
                        codigo_via_emb:parseInt(response.data.via_emb)>0?response.data.via_emb:'',
                        codigo_lab:parseInt(response.data.lab)>0?response.data.lab:'',
                    });

                }

            });
        }
        else if(prospectoid == null && self.state.proveedor.id)
        {            
            self.resetModal();
        }
    }

   

    resetModal(){
        this.setState({
          proveedor: {
                id:0,
                activo:true,
                nombre:'',
                contacto : '',
                linea:'',
                direccion : '',
                ciudad:'',
                codigo_postal:'',
                rfc : '',
                telefono: '',                             
                fax:'',
                plazo_credito:0,
                credito_disponible:0,
                cuenta_cargo:'',
                cuenta_abono:'',
                lab:0, 
                via_emb:0,               
                nota:'',
                tipo_gastos:0,
            },
            action: 'save_proveedor',
             activeTab: '1',

             modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',

            codigo_lab:'',
            codigo_via_emb:'',
        });
        
    }

    



    handleInputChange(event) {
        let {proveedor} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value=0;
            if(target.checked)
                value=1;
        }

        proveedor[name] = value;
     
        this.setState({
            proveedor : proveedor
        });
    }
   
    objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {proveedor} = this.state;
        let action=this.state.action;
        console.log("action---->",action)
        let save=true;
        let dato="";
        let self = this;
        var patt = new RegExp("[a-zA-Z0-9]?[a-zA-Z0-9]{11}[a-zA-Z0-9]$", "i");         
        if(proveedor.rfc.length>11&&proveedor.rfc.search(patt)==0){
            let check = ['rfc', 'nombre','telefono'];

            for(let i in check) {

            let key = check[i];

            let value = proveedor[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
            }     


        if(save){
           proveedor=this.objeto_mayusculas(proveedor);
         api().post(`/validacion_proveedor`, proveedor)
        .then(function(response)
        {
            
           let result= response.data;
           console.log(result);
           console.log(result.encontrado.length)           
            if(result.encontrado.length===0||parseInt(proveedor.id)>0){
                  self.props[action](proveedor, (data) => {
                    swal({
                        title: 'Proveedor',
                        text: 'Proveedor Guardado correctamente!',
                        type: 'success',
                        // showCancelButton: true,
                        // confirmButtonColor: '#3085d6',
                        // cancelButtonColor: '#d33',
                        confirmButtonText: 'Continue!'
                    }).then((result) => {
                        if (result.value) {                       
                            self.props.toggle();
                            self.resetModal();
                        }
                    })
                });

            }else{
                if(proveedor.rfc==="XAXX010101000"){
                    swal("Oops..", "No se registro el proveedor por que Se encontro un proveedor con los mismos datos ");
                }else{
                    swal("Oops..", "No se registro el proveedor por que  Se encontro un proveedor con el mismo RFC  ");
                }
            }


          });

        }else{
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }

        


        }else{
            swal("Oops..", "Por favor Verificar el RFC ");
        }

      

    }

    render()
    {

        let {proveedor}=this.state;
  
        
        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form onSubmit={this.handleSubmit} >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                     <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Datos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle_tab('2'); }}
                        >
                         Nota
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Codigo</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="id"
                                    value={proveedor.id} readOnly  />
                            </FormGroup>
                        </div>

                        <div className="col-md-3 pt-3">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="activo" 
                                        checked={proveedor.activo }
                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;Proveedor activo
                                    </label>
                                    </div>
                                </div>
                        </div>
                         <div className="row mt-3 form_cliente">       
                        <div className="col-md-12">
                            <FormGroup>
                                <Label>Nombre *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="nombre"
                                    value={proveedor.nombre}
                                    onChange={ this.handleInputChange}
                                    required
                                    className={"form-control"}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label>RFC *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="rfc"
                                    maxLength={13}
                                    value={proveedor.rfc}
                                    onChange={ this.handleInputChange}
                                     required
                                    className={"form-control"}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-5">
                            <FormGroup>
                                <Label>Contacto *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="contacto"
                                    value={proveedor.contacto}
                                    onChange={ this.handleInputChange}
                                    required
                                    className={"form-control"}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Linea</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="linea"
                                    value={proveedor.linea}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                         <div className="col-md-12">
                            <FormGroup>
                                <Label>Direccion *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="direccion"
                                    value={proveedor.direccion}
                                    onChange={ this.handleInputChange}
                                     required
                                    className={"form-control"}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label>Ciudad *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="ciudad"
                                    value={proveedor.ciudad}
                                    onChange={ this.handleInputChange}
                                     required
                                    className={"form-control"}
                                    />
                            </FormGroup>
                        </div>
                         <div className="col-md-4">
                            <FormGroup>
                                <Label>Codigo Postal *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="codigo_postal"
                                    value={proveedor.codigo_postal}
                                    onChange={ this.handleInputChange}
                                     required
                                    className={"form-control"}
                                    />
                            </FormGroup>
                        </div>
                          <div className="col-md-4">
                            <FormGroup>
                                <Label>Telefonos *</Label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="telefono"
                                    value={proveedor.telefono}
                                    onChange={ this.handleInputChange}
                                     required
                                    className={"form-control"}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label>Fax</Label>
                                    <Input
                                    placeholder=""
                                    type="tel"
                                    name="fax"
                                    value={proveedor.fax}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-12 col-sm-4 col-md-2">
                              <div className="form-group">
                                <label className>Tipo de Gastos:</label>
                                <Select
                                  placeholder=""
                                  type="text"
                                  name="tipo_gastos"
                                  options={tipos_precios}
                                  value={parseInt(proveedor.tipo_gastos) || 0}
                                  onChange={ (select) => { this.handleSelectChange(select, 'tipo_gastos') } }
                                  clearable={false}
                                  className="form-group"
                                />
                              </div>
                            </div>
                        <div className="col-md-12">
                        <div className="row">
                        <div className="col-md-4"> 
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Plazo Credito</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="plazo_credito"
                                    value={proveedor.plazo_credito}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Credito Disponible *</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="credito_disponible"
                                    value={proveedor.credito_disponible}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>                                                                                    
                        </div>
                        <div className="col-md-4"> 
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Cuenta Cargo</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="cuenta_cargo"
                                    value={proveedor.cuenta_cargo}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Cuenta Abono:</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="cuenta_abono"
                                    value={proveedor.cuenta_abono}
                                    onChange={ this.handleInputChange}
                                    />
                                </div>
                            </div>                                                                                   
                        </div>
                        <div className="col-md-4"> 
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className="d-block">Codigo Via/Emb:</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="codigo_via_emb"
                                    value={this.state.codigo_via_emb}
                                    onChange={ this.ChangeCode}
                                    onBlur={this.handleClose}
                                    className="input_button"
                                    />
                                    <Button onClick={ (button) => { this.toggle_modal(21,"Vias de Embarque","via_emb") } }>...</Button>
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className="d-block">Codigo de Lab:</label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="codigo_lab"
                                    value={this.state.codigo_lab}
                                    onChange={ this.ChangeCode}
                                    onBlur={this.handleClose}
                                    className="input_button"
                                    
                                    />
                                    <Button onClick={ (button) => { this.toggle_modal(22,"Conceptos Lab","lab") } }>...</Button>
                                </div>
                            </div>                           
                        </div>


                        </div>
                        
                       
                        
                        
                      
                        </div>
                        
                    </div>
                           
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Nota</label>
                                    <Input
                                      rows={10}                                                        
                                      type="textarea"
                                      name="nota"
                                      value={proveedor.nota} 
                                      maxLength={450}
                                      onChange={ this.handleInputChange}

                                      />
                                    
                                </div>
                            </div>                                   
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane>                      
                    </TabContent>
                    
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.proveedores.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"   >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
                <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    agregar={this.toggle_modal_registro}
                />

                {
                   this.state.modal_registro==21&& 
                   <Embarques 
                 open={this.state.modal_registro} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==22&& 
                   <LAB
                 open={this.state.modal_registro} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
               
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        proveedores : state.proveedores,
    }
};

export default connect(mapStateToProps, actions)(ProveedorModal)


// WEBPACK FOOTER //
// ./src/views/proveedores/Modal.js